import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import VueAxios from 'vue-axios'
import Axios from 'axios'
import GlobalMixin from './mixins/GlobalMixin'
import store from './store'

Vue.config.productionTip = false;
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas)
Vue.component('vue-fontawesome', FontAwesomeIcon)

Vue.use(VueAxios, Axios)
Vue.mixin(GlobalMixin)

Vue.use(Buefy, { defaultIconComponent: 'vue-fontawesome', defaultIconPack: 'fas' })

fetch(process.env.VUE_APP_BASE_URL + 'config.json')
  .then(resp => resp.json())
  .then(config => {
    Vue.prototype.$config = config
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  })

